import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom'; 
import { db, auth } from '../firebaseConfig'; // 👈 auth IMPORT KIYA HAI YAHAN
import { collection, onSnapshot, doc, writeBatch, getDocs, serverTimestamp, deleteDoc } from "firebase/firestore";

import { Users, UploadCloud, UserPlus, Database, FileText, Zap, X, CheckCircle, Send, Loader2, Trash2, CheckSquare, MessageSquare, Bold, Italic, Strikethrough, Clock, History, BarChart3, IndianRupee, AlertTriangle, AlertCircle, Rocket, RefreshCw, ImagePlus, Wand2, MousePointerClick } from 'lucide-react';

const AudienceManager = () => {
  const [allClients, setAllClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState('client_1030776826781583'); 
  const [clientData, setClientData] = useState(null); 
  const [leads, setLeads] = useState([]);
  const [isAutoSettingUp, setIsAutoSettingUp] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState('');
  
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedForCampaign, setSelectedForCampaign] = useState([]);
  const [isCampaignRunning, setIsCampaignRunning] = useState(false);
  const [progressCount, setProgressCount] = useState(0);

  const [selectedRows, setSelectedRows] = useState([]);
  const [isComposeOpen, setIsComposeOpen] = useState(false);
  const [customMessage, setCustomMessage] = useState("");

  const [activeTab, setActiveTab] = useState('DATABASE');
  const [sourceFilter, setSourceFilter] = useState('ALL'); 
  const [campaignHistory, setCampaignHistory] = useState([]);
  
  const isAdmin = true; 
  const [isRecharging, setIsRecharging] = useState(false);

  const [metaTemplates, setMetaTemplates] = useState([]);
  const [isFetchingTemplates, setIsFetchingTemplates] = useState(false);
  const [selectedTemplateIndex, setSelectedTemplateIndex] = useState("");
  const [templateVariables, setTemplateVariables] = useState([]); 
  const [campaignImage, setCampaignImage] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);

  const MESSAGE_COST = 0.80; 
  const LOW_BALANCE_THRESHOLD = 50.00;

  const templates = [
      { 
          title: "Special Offer 🎁", 
          name: "universal_business_promo", 
          language: "en",
          text: "We have an exclusive offer just for you! 🎉 Get *20% OFF* on our premium services today. Reply 'YES' to claim this offer." 
      },
      { 
          title: "Important Update 🚀", 
          name: "universal_business_promo", 
          language: "en",
          text: "We have a quick update for you! 📢 Our new batches/services are starting from this Monday. Ensure your spot by replying to this message." 
      },
      { 
          title: "Feedback Request ⭐", 
          name: "universal_business_promo", 
          language: "en",
          text: "It's been a while! We would love to hear about your experience with us. Please share your quick feedback here: [Link]" 
      }
  ];

  useEffect(() => {
    const fetchClients = async () => {
      const snap = await getDocs(collection(db, "clients"));
      setAllClients(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    };
    fetchClients();
  }, []);

  useEffect(() => {
    if (!selectedClientId) return;
    const unsub = onSnapshot(doc(db, "clients", selectedClientId), (docSnap) => {
      if (docSnap.exists()) setClientData(docSnap.data());
    });
    return () => unsub();
  }, [selectedClientId]);

  useEffect(() => {
    if (!selectedClientId) return;
    const leadsRef = collection(db, "clients", selectedClientId, "leads");
    const unsub = onSnapshot(leadsRef, (snapshot) => {
      const leadsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      leadsData.sort((a, b) => {
          const timeA = a.timestamp?.toMillis ? a.timestamp.toMillis() : (a.timestamp?.getTime ? a.timestamp.getTime() : 0);
          const timeB = b.timestamp?.toMillis ? b.timestamp.toMillis() : (b.timestamp?.getTime ? b.timestamp.getTime() : 0);
          return timeB - timeA;
      });
      setLeads(leadsData);
    });
    return () => unsub();
  }, [selectedClientId]);

  useEffect(() => {
      setCampaignHistory([
          { id: 1, date: new Date(), name: "Diwali Offer Blast", sent: 45, failed: 2, total: 47, cost: 45 * MESSAGE_COST, type: "CUSTOM" },
          { id: 2, date: new Date(Date.now() - 86400000), name: "Auto SEO Drip", sent: 5, failed: 0, total: 5, cost: 5 * MESSAGE_COST, type: "SEO_DRIP" },
          { id: 3, date: new Date(Date.now() - 172800000), name: "Auto SEO Drip", sent: 5, failed: 1, total: 6, cost: 5 * MESSAGE_COST, type: "SEO_DRIP" }
      ]);
  }, [selectedClientId]);

  useEffect(() => {
      if (selectedClientId) {
          handleFetchTemplates();
      }
  }, [selectedClientId]);

  const handleImageSelect = (e) => {
      const file = e.target.files[0];
      if (file) {
          if (file.size > 5 * 1024 * 1024) return alert("Image 5MB se choti honi chahiye (WhatsApp limit).");
          setCampaignImage(file);
          setImagePreviewUrl(URL.createObjectURL(file));
      }
  };

  const removeImage = () => {
      setCampaignImage(null);
      setImagePreviewUrl(null);
  };

  const handleSelectAll = (e) => {
      if (e.target.checked) setSelectedRows(leads.map(l => l.id)); 
      else setSelectedRows([]);
  };

  const handleSelectRow = (id) => {
      setSelectedRows(prev => prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]);
  };

  const handleSelectActiveLeads = () => {
      const now = Date.now();
      const activeIds = leads
          .filter(lead => {
              const leadTime = lead.lastMessageAt?.toMillis ? lead.lastMessageAt.toMillis() : 
                               (lead.timestamp?.toMillis ? lead.timestamp.toMillis() : 0);
              return leadTime > 0 && (now - leadTime) < (24 * 60 * 60 * 1000);
          })
          .map(l => l.id);

      if (activeIds.length === 0) {
          alert("Pichle 24 ghante mein koi bhi active lead nahi mili.");
          setSelectedRows([]);
      } else {
          setSelectedRows(activeIds);
          alert(`✅ ${activeIds.length} Active leads select ho gayi hain. Inhe message bhejna FREE hai!`);
      }
  };

  const handleBulkDelete = async () => {
      if (!window.confirm(`Kya aap sach mein in ${selectedRows.length} leads ko delete karna chahte hain?`)) return;
      const batch = writeBatch(db);
      selectedRows.forEach(id => batch.delete(doc(db, "clients", selectedClientId, "leads", id)));
      try { await batch.commit(); setSelectedRows([]); } catch (error) { alert("Delete error."); }
  };

  const handleBulkStatusChange = async (newStatus) => {
      if (!newStatus) return;
      const batch = writeBatch(db);
      selectedRows.forEach(id => batch.update(doc(db, "clients", selectedClientId, "leads", id), { status: newStatus }));
      try { await batch.commit(); setSelectedRows([]); } catch (error) { alert("Status update error."); }
  };

  const openCampaignPreview = () => {
    const manuallySelectedEnrolled = leads.filter(l => selectedRows.includes(l.id) && l.status === "ENROLLED");
    const targetLeads = manuallySelectedEnrolled.length > 0 ? manuallySelectedEnrolled.slice(0, 5) : leads.filter(l => l.status === "ENROLLED").slice(0, 5);
    if (targetLeads.length === 0) return alert("Koi 'ENROLLED' student nahi mila.");
    setSelectedForCampaign(targetLeads); setIsPreviewOpen(true);
  };

  const canAffordCampaign = (count) => {
      if (isAdmin) return true; 
      const totalCost = count * MESSAGE_COST;
      return (clientData?.walletBalance || 0) >= totalCost;
  };

  const handleRecharge = async () => {
      const amountStr = window.prompt(`Workspace: ${clientData?.name || selectedClientId}\nKitne Rupaye (₹) ka recharge karna hai?\n(Minimum ₹100)`, "1000");
      if (!amountStr) return;
      const amount = parseInt(amountStr);
      if (isNaN(amount) || amount < 100) return alert("❌ Please enter a valid amount (Min ₹100).");

      setIsRecharging(true);
      try {
          const response = await fetch("https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/createRechargeLink", {
              method: "POST", headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ clientId: selectedClientId, amount: amount })
          });
          const data = await response.json();
          if (response.ok && data.success) window.open(data.url, '_blank'); 
          else alert(`❌ Link Error: ${data.error}`);
      } catch (error) { alert("❌ Server se connect nahi ho paya."); }
      setIsRecharging(false);
  };

  // 🛡️ API SECURED: triggerDashboardCampaign
  const handleLaunchCampaign = async () => {
    if (!canAffordCampaign(selectedForCampaign.length)) return alert(`❌ Recharge Required! Balance low hai.`);

    setIsCampaignRunning(true); setProgressCount(0);
    const interval = setInterval(() => { setProgressCount(prev => prev < selectedForCampaign.length ? prev + 1 : prev); }, 800);

    try {
        const userToken = await auth.currentUser.getIdToken(); // 👈 TOKEN FETCH KIYA
        const response = await fetch("https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/triggerDashboardCampaign", {
            method: "POST", 
            headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${userToken}` // 👈 TOKEN BHEJA
            },
            body: JSON.stringify({ clientId: selectedClientId, audienceType: "ENROLLED" })
        });
        const data = await response.json();
        clearInterval(interval);
        
        if (response.ok && data.success) {
            setProgressCount(selectedForCampaign.length);
            setCampaignHistory(prev => [{ id: Date.now(), date: new Date(), name: "Auto SEO Drip", sent: data.count, failed: 0, total: data.count, cost: data.count * MESSAGE_COST, type: "SEO_DRIP" }, ...prev]);
            setTimeout(() => {
                alert(`✅ Successful! ${data.count} review links sent.`);
                setIsPreviewOpen(false); setIsCampaignRunning(false); setSelectedRows([]); 
            }, 600);
        } else { alert(`❌ Error: ${data.error}`); setIsCampaignRunning(false); }
    } catch (error) { clearInterval(interval); alert("❌ Backend Error."); setIsCampaignRunning(false); }
  };

  const downloadSampleCSV = () => {
    const headers = "Phone,Name,Status\n";
    const rows = "919876543210,Rahul Sharma,ENROLLED\n918888888888,Priya Singh,DROPPED";
    const blob = new Blob([headers + rows], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    link.setAttribute("href", URL.createObjectURL(blob));
    link.setAttribute("download", "Pivot_CRM_Template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFetchTemplates = async () => {
      if (!selectedClientId) return;
      setIsFetchingTemplates(true);
      try {
          const response = await fetch("https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/getClientTemplates", {
              method: "POST", headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ clientId: selectedClientId })
          });
          const data = await response.json();
          if (response.ok && data.success) {
              setMetaTemplates(data.templates);
              if (data.templates.length === 0) console.log("Meta par is client ka koi bhi 'Approved' template nahi mila.");
          } else console.error(`Fetch Error: ${data.error}`);
      } catch (error) { console.error("API Connect Error."); }
      setIsFetchingTemplates(false);
  };

  const handleAutoSetupTemplates = async () => {
      const targetId = selectedClientId; 
      if (!targetId) return alert("Pehle target Workspace select karein!");
      
      if (!window.confirm("Kya aap is business ke Meta account mein automatically 'Universal Master Template' install karna chahte hain?")) return;

      setIsAutoSettingUp(true);
      try {
          const response = await fetch("https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/autoSetupMetaTemplates", {
              method: "POST", headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ clientId: targetId })
          });
          const data = await response.json();
          
          if (response.ok && data.success) {
              alert("✅ Success! Master Template Meta ko bhej diya gaya hai. Meta ka AI ise 30-60 seconds mein approve kar dega. Phir 'Sync Meta' dabayein.");
              setTimeout(() => handleFetchTemplates(), 2000); 
          } else { 
              alert(`❌ Meta Error: ${data.error}`); 
          }
      } catch (error) { 
          alert("❌ Server Connection Error."); 
      }
      setIsAutoSettingUp(false);
  };

  const handleTemplateSelect = (e) => {
      const idx = e.target.value;
      setSelectedTemplateIndex(idx);
      setCustomMessage(""); 

      if (idx !== "" && metaTemplates[idx]) {
          const bodyComponent = metaTemplates[idx].components.find(c => c.type === 'BODY');
          if (bodyComponent && bodyComponent.text) {
              const matches = bodyComponent.text.match(/\{\{(\d+)\}\}/g);
              const count = matches ? matches.length : 0;
              setTemplateVariables(new Array(count).fill("")); 
          } else {
              setTemplateVariables([]);
          }
      } else {
          setTemplateVariables([]);
      }
  };

  const handleVariableChange = (index, value) => {
      const newVars = [...templateVariables];
      newVars[index] = value;
      setTemplateVariables(newVars);
  };

  // 🛡️ API SECURED: sendBulkCustomMessage
  const handleSendCustomMessage = async () => {
      if (!customMessage.trim() && !campaignImage && templateVariables.length === 0) return alert("Pehle message likhein ya image select karein!");
      if (selectedRows.length === 0) return alert("Kam se kam ek lead select karein.");
      if (!canAffordCampaign(selectedRows.length)) return alert(`❌ Wallet Balance Low! Recharge karein.`);
      if (!window.confirm(`Kya aap in ${selectedRows.length} logo ko WhatsApp message bhejna chahte hain?`)) return;

      setIsCampaignRunning(true); setProgressCount(0);
      const interval = setInterval(() => { setProgressCount(prev => prev < selectedRows.length ? prev + 1 : prev); }, 500);

      let payloadMessage = customMessage;
      if (selectedTemplateIndex !== "") {
          payloadMessage = templateVariables.length > 1 ? templateVariables.slice(1).join(" | ") : "Template Blast";
      }

      try {
          const userToken = await auth.currentUser.getIdToken(); // 👈 TOKEN FETCH KIYA
          const response = await fetch("https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/sendBulkCustomMessage", {
              method: "POST", 
              headers: { 
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${userToken}` // 👈 TOKEN BHEJA
              },
           body: JSON.stringify({ 
                  clientId: selectedClientId, 
                  leadIds: selectedRows, 
                  messageText: payloadMessage,
                  templateVariables: templateVariables, 
                  templateName: selectedTemplateIndex !== "" ? metaTemplates[selectedTemplateIndex].name : undefined,
                  languageCode: selectedTemplateIndex !== "" ? metaTemplates[selectedTemplateIndex].language : undefined
              })
          });
          const data = await response.json();
          clearInterval(interval);
          if (response.ok && data.success) {
              setProgressCount(selectedRows.length);
              setCampaignHistory(prev => [{ id: Date.now(), date: new Date(), name: "Custom Broadcast", sent: data.count, failed: selectedRows.length - data.count, total: selectedRows.length, cost: data.count * MESSAGE_COST, type: "CUSTOM" }, ...prev]);
              setTimeout(() => {
                  alert(`✅ Broadcast Successful! ${data.count} messages sent.`);
                  setIsComposeOpen(false); setIsCampaignRunning(false); setCustomMessage(""); removeImage(); setSelectedRows([]);
              }, 600);
          } else { alert(`❌ Error: ${data.error}`); setIsCampaignRunning(false); }
      } catch (error) { clearInterval(interval); alert("❌ API connect nahi ho payi."); setIsCampaignRunning(false); }
  };

  const handleFileUpload = async (event) => {
      const file = event.target.files[0];
      if (!file) return;
      if (!selectedClientId) return alert("Pehle Workspace select karein!");
      if (!file.name.endsWith('.csv')) { alert("❌ Kripya sirf .CSV file upload karein."); event.target.value = null; return; }
  
      setIsUploading(true); setUploadStatus('Scanning CSV Format...');
      const reader = new FileReader();
      reader.onload = async (e) => {
        const text = e.target.result.replace(/\r/g, ''); 
        const rows = text.split('\n').filter(row => row.trim().length > 0);
        if (rows.length < 2) { alert("❌ CSV empty hai!"); setIsUploading(false); return; }
  
        const headers = rows[0].split(',').map(h => h.replace(/[^a-zA-Z0-9]/g, '').toLowerCase());
        const phoneIdx = headers.findIndex(h => h.includes('phone') || h.includes('number') || h.includes('mobile'));
        const nameIdx = headers.findIndex(h => h.includes('name') || h.includes('student'));
        const statusIdx = headers.findIndex(h => h.includes('status'));
  
        if (phoneIdx === -1) { alert("❌ CSV mein 'Phone' column nahi mila!"); setIsUploading(false); return; }
        const validRows = rows.slice(1); setUploadStatus(`Saving...`);
  
        try {
          const batch = writeBatch(db);
          let count = 0;
          validRows.forEach(row => {
            const cols = row.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map(c => c.replace(/^"|"$/g, '').trim());
            const rawPhone = cols[phoneIdx];
            const cleanPhone = rawPhone?.replace(/\D/g, "");
            if (!cleanPhone || cleanPhone.length < 10) return;
  
            batch.set(doc(db, "clients", selectedClientId, "leads", cleanPhone), {
              phone: cleanPhone,
              studentName: (nameIdx !== -1 ? cols[nameIdx] : "Student") || "Student",
              status: (statusIdx !== -1 && cols[statusIdx] ? cols[statusIdx].toUpperCase() : "ENROLLED"),
              source: "CSV Upload", timestamp: serverTimestamp() 
            }, { merge: true });
            count++;
          });
          await batch.commit(); alert(`✅ Success! ${count} naye students database mein add ho gaye.`);
        } catch (error) { alert("❌ Upload failed."); }
        setIsUploading(false); event.target.value = null; setUploadStatus('');
      };
      reader.readAsText(file);
  };

  const insertText = (format) => setCustomMessage(prev => prev + format);
  
  const formatWhatsAppText = (text) => {
      if (!text) return null;
      let formatted = text.replace(/\[Name\]/gi, "Rahul Sharma").replace(/\*(.*?)\*/g, "<strong>$1</strong>").replace(/_(.*?)_/g, "<em>$1</em>").replace(/~(.*?)~/g, "<del>$1</del>").replace(/\n/g, "<br/>");
      return <span dangerouslySetInnerHTML={{ __html: formatted }} />;
  };

  const getLivePreviewText = () => {
      if (selectedTemplateIndex !== "" && metaTemplates[selectedTemplateIndex]) {
          const selectedTemplate = metaTemplates[selectedTemplateIndex];
          const bodyComponent = selectedTemplate.components.find(c => c.type === 'BODY');
          
         if (bodyComponent) {
              let text = bodyComponent.text;
              text = text.replace(/\{\{1\}\}/g, "Rahul Sharma"); 
              
              templateVariables.forEach((val, idx) => {
                  if (idx > 0) { 
                      const regex = new RegExp(`\\{\\{${idx + 1}\\}\\}`, 'g');
                      text = text.replace(regex, val || `[Box ${idx + 1} ka text]`);
                  }
              });
              return formatWhatsAppText(text);
          }
      }
      return customMessage ? formatWhatsAppText(customMessage) : <span className="text-slate-400 italic text-[11px]">{imagePreviewUrl ? "Caption..." : "Message preview..."}</span>;
  };

  const enrolledCount = leads.filter(l => l.status === "ENROLLED").length;
  const organicCount = leads.filter(l => !l.source || l.source === 'ORGANIC').length;
const blastCount = leads.filter(l => l.source === 'WHATSAPP_BLAST').length;
const csvCount = leads.filter(l => l.source === 'CSV Upload').length;
const filteredLeads = leads.filter(lead => {
  if (sourceFilter === 'ALL') return true;
  if (sourceFilter === 'ORGANIC') return !lead.source || lead.source === 'ORGANIC';
  return lead.source === sourceFilter;
});
  const totalSpent = campaignHistory.reduce((acc, curr) => acc + curr.cost, 0);
  const totalSent = campaignHistory.reduce((acc, curr) => acc + curr.sent, 0);
  const walletBalance = clientData?.walletBalance || 0;
  const isLowBalance = walletBalance < LOW_BALANCE_THRESHOLD;

  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-6 max-w-5xl mx-auto space-y-6 animate-in fade-in relative pb-24">
      {/* HEADER WITH WALLET INDICATOR */}
      <div className="flex flex-col md:flex-row md:items-center justify-between border-b border-slate-100 pb-4 gap-4">
        <div className="flex items-center gap-3 flex-1">
          <div className="bg-emerald-100 p-2.5 rounded-xl"><Users className="w-6 h-6 text-emerald-600"/></div>
          <div>
            <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight">Audience CRM</h2>
            <div className="flex items-center gap-2 mt-1">
                <span className="text-[10px] font-bold text-slate-400 uppercase">Active Workspace:</span>
                <select value={selectedClientId} onChange={(e) => setSelectedClientId(e.target.value)} className="text-[10px] font-black text-indigo-600 outline-none bg-transparent cursor-pointer border-b border-dashed border-indigo-200 pb-0.5">
                    {allClients.map(c => <option key={c.id} value={c.id}>{c.name || c.id}</option>)}
                </select>
            </div>
          </div>
        </div>

        <div className={`px-4 py-3 rounded-2xl flex items-center gap-3 shadow-lg border shrink-0 transition-colors ${isLowBalance && !isAdmin ? 'bg-rose-900 border-rose-800 animate-pulse shadow-rose-900/20' : 'bg-slate-900 border-slate-800'}`}>
            <div className={`p-1.5 rounded-lg ${isLowBalance && !isAdmin ? 'bg-rose-500/20 text-rose-400' : 'bg-emerald-500/20 text-emerald-400'}`}><IndianRupee size={16} /></div>
            <div>
                <p className={`text-[9px] font-black uppercase tracking-widest ${isLowBalance && !isAdmin ? 'text-rose-400' : 'text-slate-500'}`}>Blast Credits</p>
                <div className="flex items-center gap-2">
                    <h4 className="text-sm font-black text-white">₹{walletBalance.toFixed(2)}</h4>
                    {isAdmin && <span className="bg-indigo-500 text-white text-[8px] px-1.5 py-0.5 rounded uppercase tracking-widest">Admin Bypass</span>}
                </div>
            </div>
            <button onClick={handleRecharge} disabled={isRecharging} className="ml-2 bg-white/10 hover:bg-white/20 p-1.5 rounded-md transition-colors flex items-center gap-1 group disabled:opacity-50" title="Recharge via Razorpay">
                {isRecharging ? <Loader2 size={14} className="text-white animate-spin"/> : <Zap size={14} className={isLowBalance && !isAdmin ? 'text-rose-400' : 'text-amber-400'}/>}
                <span className="text-[10px] font-bold text-white hidden group-hover:block transition-all">Add</span>
            </button>
        </div>
      </div>

      {/* 🔥 LOW BALANCE POKE BANNER */}
      {isLowBalance && !isAdmin && (
          <div className="bg-rose-50 border border-rose-200 p-3 rounded-xl flex items-center justify-between shadow-inner animate-in slide-in-from-top-4">
              <div className="flex items-center gap-3 text-rose-700">
                  <AlertTriangle size={18} className="text-rose-500" />
                  <div>
                      <h4 className="text-xs font-black uppercase tracking-wider">Low Credits Alert</h4>
                      <p className="text-[11px] font-medium mt-0.5 text-rose-600">Aapka balance ₹{LOW_BALANCE_THRESHOLD} se kam hai. Campaigns rukne se bachane ke liye recharge karein.</p>
                  </div>
              </div>
              <button onClick={handleRecharge} disabled={isRecharging} className="bg-rose-600 hover:bg-rose-700 text-white text-xs font-black px-4 py-2 rounded-lg shadow-sm transition-colors whitespace-nowrap uppercase tracking-wider disabled:opacity-50">
                  {isRecharging ? 'Processing...' : 'Recharge Now'}
              </button>
          </div>
      )}

      {/* TABS */}
      <div className="flex p-1 bg-slate-100 rounded-xl w-full max-w-sm">
        <button onClick={() => setActiveTab('DATABASE')} className={`flex-1 flex items-center justify-center gap-2 py-2 rounded-lg text-xs font-black uppercase tracking-widest transition-all ${activeTab === 'DATABASE' ? 'bg-white text-indigo-600 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}>
            <Database size={14}/> Database
        </button>
        <button onClick={() => setActiveTab('HISTORY')} className={`flex-1 flex items-center justify-center gap-2 py-2 rounded-lg text-xs font-black uppercase tracking-widest transition-all ${activeTab === 'HISTORY' ? 'bg-white text-indigo-600 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}>
            <History size={14}/> History
        </button>
      </div>

      {activeTab === 'DATABASE' && (
        <div className="space-y-6 animate-in fade-in">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-slate-50 border border-slate-100 p-5 rounded-xl flex flex-col justify-between">
                    <div>
                        <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">Total Database</p>
                        <h3 className="text-3xl font-black text-slate-800">{leads.length}</h3>
                    </div>
                    {/* 🔥 NEW SMART SELECT BUTTON HERE */}
                    <button 
                        onClick={handleSelectActiveLeads}
                        className="mt-4 flex items-center justify-center gap-2 text-[10px] font-black uppercase tracking-widest bg-emerald-50 text-emerald-600 border border-emerald-100 py-2 rounded-lg hover:bg-emerald-600 hover:text-white transition-all shadow-sm"
                    >
                        <MousePointerClick size={14} /> Select Free Leads 🟢
                    </button>
                </div>

                <div className="bg-indigo-50 border border-indigo-200 p-5 rounded-xl relative flex flex-col justify-between overflow-hidden shadow-inner group">
                    <div className="relative z-10">
                        <p className="text-[10px] font-black text-indigo-500 uppercase tracking-widest mb-1">Auto-Review Drip</p>
                        <div className="flex items-end gap-2">
                            <h3 className="text-3xl font-black text-indigo-700">{enrolledCount}</h3>
                            <span className="text-xs font-bold text-indigo-400 mb-1">Enrolled</span>
                        </div>
                    </div>
                    <button onClick={openCampaignPreview} disabled={enrolledCount === 0 && selectedRows.length === 0} className="mt-4 w-full bg-indigo-600 text-white font-black py-3 rounded-lg text-xs uppercase tracking-widest hover:bg-indigo-700 transition-all shadow-md disabled:opacity-50 flex items-center justify-center gap-2 relative z-10">
                        <Zap size={16} className={enrolledCount > 0 ? "animate-pulse" : ""} /> Launch SEO Drip
                    </button>
                </div>

                {/* CSV UPLOAD CARD */}
                <div className="bg-emerald-50 border border-emerald-100 p-5 rounded-xl flex flex-col justify-center gap-3 border-dashed">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2 text-emerald-600">
                            <Database className="w-5 h-5" />
                            <span className="text-[10px] font-black uppercase tracking-widest">Import Leads</span>
                        </div>
                    </div>
                   <div className="w-full">
                        <label className={`cursor-pointer bg-emerald-600 text-white font-black px-4 py-2.5 rounded-lg text-[10px] uppercase tracking-widest hover:bg-emerald-700 transition-all shadow-md flex items-center justify-center gap-2 w-full mt-1 ${isUploading ? 'opacity-50' : ''}`}>
                            {isUploading ? <><Loader2 size={14} className="animate-spin"/> Parsing...</> : <><UploadCloud size={14}/> Select CSV File</>}
                            <input type="file" accept=".csv" className="hidden" onChange={handleFileUpload} disabled={isUploading} />
                        </label>
                        <div className="mt-2 text-center">
                            <button onClick={downloadSampleCSV} className="text-[10px] font-bold text-emerald-600 hover:text-emerald-800 underline tracking-tighter transition-colors">
                                📥 Download Sample CSV Template
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="border border-slate-200 rounded-xl shadow-sm overflow-hidden bg-white">
              {/* 🔥 NEW: SMART LEAD FILTER */}
            <div className="flex justify-between items-center bg-slate-50 border-b border-slate-200 px-4 py-3 rounded-t-xl">
                <h3 className="font-black text-xs text-slate-500 uppercase tracking-widest">Database Explorer</h3>
                <select 
                    value={sourceFilter} 
                    onChange={(e) => setSourceFilter(e.target.value)} 
                    className="bg-white border border-slate-200 text-slate-700 text-[10px] font-black uppercase tracking-widest rounded-lg px-3 py-1.5 outline-none cursor-pointer shadow-sm hover:border-indigo-300 transition-colors"
                >
                    <option value="ALL">🌍 All Leads</option>
                    <option value="ORGANIC">📍 Organic (Google / Meta Ads)</option>
                    <option value="WhatsApp Blast">🚀 WhatsApp Blast</option>
                    <option value="CSV Upload">📁 CSV Uploads</option>
                </select>
            </div>
                <div className="overflow-y-auto max-h-[400px] custom-scrollbar">
                    <table className="w-full text-left table-fixed">
                        <thead className="sticky top-0 bg-slate-50 border-b border-slate-200 text-[10px] font-black text-slate-500 uppercase tracking-widest z-20">
                            <tr>
                                <th className="px-4 py-4 w-12"><input type="checkbox" onChange={handleSelectAll} checked={selectedRows.length === leads.length && leads.length > 0} className="w-4 h-4 rounded border-slate-300 text-indigo-600" /></th>
                                <th className="px-4 py-4">Student Name</th>
                                <th className="px-4 py-4">Phone</th>
                                <th className="px-4 py-4">Status</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            {filteredLeads.map((lead) => {
                                // 🧠 24-HOUR BADGE LOGIC
                                const now = Date.now();
                                const leadTime = lead.lastMessageAt?.toMillis ? lead.lastMessageAt.toMillis() : 
                                                 (lead.timestamp?.toMillis ? lead.timestamp.toMillis() : 0);
                                const is24hActive = leadTime > 0 && (now - leadTime) < (24 * 60 * 60 * 1000);

                                return (
                                <tr key={lead.id} className={`hover:bg-slate-50 transition-colors ${selectedRows.includes(lead.id) ? 'bg-indigo-50/50' : ''}`}>
                                    <td className="px-4 py-3"><input type="checkbox" checked={selectedRows.includes(lead.id)} onChange={() => handleSelectRow(lead.id)} className="w-4 h-4 rounded border-slate-300 text-indigo-600" /></td>
                                    <td className="px-4 py-3">
                                        <p className="text-sm font-bold text-slate-800 truncate">{lead.studentName || 'Student'}</p>
                                        <div className="flex flex-wrap gap-1 mt-1">
                                            {/* 🔥 MAGIC BADGE */}
                                            {is24hActive && (
                                                <span className="inline-block bg-emerald-100 text-emerald-700 text-[8px] font-black px-1.5 py-0.5 rounded uppercase tracking-wider">
                                                    🟢 24h Active
                                                </span>
                                            )}
                                            {/* 🔥 BLAST SOURCE BADGE */}
                                            {lead.source === "WhatsApp Blast" && (
                                                <span className="inline-block bg-rose-100 text-rose-700 text-[8px] font-black px-1.5 py-0.5 rounded uppercase tracking-wider">
                                                    🚀 Blast Lead
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    <td className="px-4 py-3 text-xs font-mono text-slate-600">+{lead.phone}</td>
                                    <td className="px-4 py-3"><span className="text-[10px] font-black px-2 py-1 rounded border bg-slate-50 border-slate-200">{lead.status}</span></td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      )}

      {activeTab === 'HISTORY' && (
        <div className="space-y-6 animate-in fade-in duration-300">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-slate-900 border border-slate-800 p-6 rounded-2xl flex items-center gap-4 text-white shadow-lg">
                    <div className="bg-slate-800 p-3 rounded-xl"><BarChart3 size={24} className="text-indigo-400" /></div>
                    <div>
                        <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">Total Broadcasted</p>
                        <h3 className="text-3xl font-black text-white">{totalSent} <span className="text-sm font-medium text-slate-400">Messages</span></h3>
                    </div>
                </div>
                <div className="bg-gradient-to-r from-emerald-500 to-teal-500 p-6 rounded-2xl flex items-center gap-4 text-white shadow-lg shadow-emerald-500/20">
                    <div className="bg-white/20 p-3 rounded-xl"><IndianRupee size={24} className="text-white" /></div>
                    <div>
                        <p className="text-[10px] font-black text-emerald-100 uppercase tracking-widest mb-1">Estimated Cost</p>
                        <h3 className="text-3xl font-black text-white">₹{totalSpent.toFixed(2)}</h3>
                    </div>
                </div>
            </div>
            <div className="border border-slate-200 rounded-xl shadow-sm overflow-hidden bg-white">
                <div className="bg-slate-50 border-b border-slate-200 px-5 py-4">
                    <h3 className="font-black text-sm text-slate-800 uppercase tracking-widest">Campaign Logs</h3>
                </div>
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead className="bg-slate-50 border-b border-slate-100 text-[10px] font-black text-slate-400 uppercase tracking-widest">
                            <tr><th className="px-5 py-3">Date</th><th className="px-5 py-3">Campaign</th><th className="px-5 py-3 text-center">Delivered</th><th className="px-5 py-3 text-center">Failed</th><th className="px-5 py-3 text-right">Cost</th></tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50">
                            {campaignHistory.map((log) => (
                                <tr key={log.id} className="hover:bg-slate-50/50 transition-colors">
                                    <td className="px-5 py-3">
                                        <p className="text-xs font-bold text-slate-800">{log.date.toLocaleDateString()}</p>
                                        <p className="text-[10px] text-slate-400 font-mono mt-0.5">{log.date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</p>
                                    </td>
                                    <td className="px-5 py-3">
                                        <span className={`text-[10px] font-black px-2 py-0.5 rounded border uppercase tracking-wider ${log.type === 'SEO_DRIP' ? 'bg-indigo-50 text-indigo-600 border-indigo-100' : 'bg-purple-50 text-purple-600 border-purple-100'}`}>{log.type}</span>
                                        <p className="text-sm font-bold text-slate-700 mt-1">{log.name}</p>
                                    </td>
                                    <td className="px-5 py-3 text-center"><span className="inline-flex items-center gap-1 bg-emerald-50 text-emerald-600 px-2 py-1 rounded-md text-xs font-bold border border-emerald-100"><CheckCircle size={12}/> {log.sent}</span></td>
                                    <td className="px-5 py-3 text-center"><span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-bold border ${log.failed > 0 ? 'bg-rose-50 text-rose-600 border-rose-100' : 'bg-slate-50 text-slate-400 border-slate-100'}`}><X size={12}/> {log.failed}</span></td>
                                    <td className="px-5 py-3 text-right"><p className="text-sm font-black text-slate-800">₹{log.cost.toFixed(2)}</p></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      )}

      {/* FLOATING ACTIONS BAR */}
      {selectedRows.length > 0 && activeTab === 'DATABASE' && (
          <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-slate-900 border border-slate-700 text-white px-4 py-3 rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] flex items-center gap-4 z-[500] animate-in slide-in-from-bottom-10 fade-in duration-300">
              <span className="font-bold text-xs bg-slate-800 px-3 py-1.5 rounded-lg flex items-center gap-2 border border-slate-700"><CheckSquare size={14} className="text-indigo-400" /> {selectedRows.length} Selected</span>
              <div className="h-6 w-px bg-slate-700"></div>
              <button onClick={() => setIsComposeOpen(true)} className="bg-indigo-600 hover:bg-indigo-500 text-white px-4 py-1.5 rounded-lg font-black text-xs flex items-center gap-2 transition-colors shadow-lg shadow-indigo-500/20 uppercase tracking-widest"><MessageSquare size={14}/> Compose Blast</button>
              <div className="h-6 w-px bg-slate-700"></div>
              <select onChange={(e) => { handleBulkStatusChange(e.target.value); e.target.value = ""; }} className="bg-slate-800 text-white border border-slate-700 rounded-lg px-3 py-1.5 text-xs font-bold outline-none hover:bg-slate-700 cursor-pointer">
                  <option value="">Status...</option><option value="ENROLLED">Mark ENROLLED</option><option value="DROPPED">Mark DROPPED</option>
              </select>
              <button onClick={handleBulkDelete} className="hover:bg-rose-500/20 text-rose-400 hover:text-rose-300 px-2 py-1.5 rounded-lg font-bold text-xs flex items-center gap-1.5 transition-colors border border-transparent hover:border-rose-500/30"><Trash2 size={16}/></button>
          </div>
      )}

      {/* 🔥 NEW MODERN COMPOSE MESSAGE MODAL (PORTAL + RESPONSIVE + IMAGE UPLOAD) 🔥 */}
      {isComposeOpen && createPortal(
        <div className="fixed inset-0 flex items-center justify-center p-3 md:p-6 bg-slate-900/80 backdrop-blur-sm animate-in fade-in duration-200" style={{ zIndex: 99999 }}>
          
          <div className="bg-white rounded-[24px] shadow-2xl w-full max-w-6xl h-[95vh] md:h-[90vh] flex flex-col overflow-hidden relative border border-slate-200/50">
            
            {/* 1. Header Area */}
            <div className="px-6 md:px-8 py-4 border-b border-slate-100 flex justify-between items-center bg-white z-10 shrink-0">
               <div className="flex items-center gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-indigo-50 rounded-2xl flex items-center justify-center text-indigo-600 border border-indigo-100">
                     <Rocket size={24} className="animate-pulse" />
                  </div>
                  <div>
                     <h2 className="text-lg md:text-2xl font-black text-slate-900 tracking-tight leading-none">Campaign Builder</h2>
                     <p className="text-[10px] md:text-xs font-bold text-slate-500 mt-1 uppercase tracking-widest flex items-center gap-2">
                         <Users size={12}/> Targeting {selectedRows.length} Contacts
                     </p>
                  </div>
               </div>
               {!isCampaignRunning && (
                   <button onClick={() => setIsComposeOpen(false)} className="w-8 h-8 md:w-10 md:h-10 bg-slate-50 hover:bg-rose-50 text-slate-400 hover:text-rose-600 rounded-full flex items-center justify-center transition-all">
                       <X size={20}/>
                   </button>
               )}
            </div>

            {/* 2. Main Content (Split Layout) */}
            <div className="flex-1 flex flex-col lg:flex-row overflow-hidden bg-slate-50/50 relative">
               
               {/* LEFT PANEL: Form & Controls */}
               <div className="w-full lg:w-[55%] p-5 md:p-6 overflow-y-auto custom-scrollbar flex flex-col gap-5 md:gap-6 bg-white z-10 h-full">
                  
                  {/* Step 1: Target Settings */}
                  <div className="space-y-2">
                     <h3 className="text-[10px] md:text-xs font-black text-slate-400 uppercase tracking-widest flex items-center gap-2">
                        <span className="w-4 h-4 md:w-5 md:h-5 rounded-full bg-slate-100 flex items-center justify-center text-[9px] md:text-[10px] text-slate-600">1</span> 
                        Audience Selection
                     </h3>
                     <div className="bg-slate-50 border border-slate-200 rounded-xl p-3 md:p-4 flex items-center justify-between">
                         <div>
                             <p className="text-xs md:text-sm font-bold text-slate-800">Custom Selection</p>
                             <p className="text-[10px] md:text-xs font-medium text-slate-500 mt-0.5">Selected from Database</p>
                         </div>
                         <div className="bg-indigo-100 text-indigo-600 px-3 py-1 rounded-lg font-black text-xs md:text-sm border border-indigo-200 shadow-sm">
                             {selectedRows.length} Leads
                         </div>
                     </div>
                  </div>

                  {/* Step 2: Templates */}
                  <div className="space-y-2">
                     <div className="flex justify-between items-center">
                        <h3 className="text-xs font-black text-slate-400 uppercase tracking-widest flex items-center gap-2">
                           <span className="w-5 h-5 rounded-full bg-slate-100 flex items-center justify-center text-[10px] text-slate-600">2</span> 
                           Meta Templates
                        </h3>
                        <div className="flex gap-2">
                            <button 
                                onClick={handleAutoSetupTemplates} 
                                disabled={isAutoSettingUp} 
                                className="text-[11px] font-black text-amber-600 bg-amber-50 hover:bg-amber-100 px-3 py-1.5 rounded-lg flex items-center gap-2 transition-colors shadow-sm disabled:opacity-50"
                                title="Auto-Install Master Template to Meta"
                            >
                                {isAutoSettingUp ? <Loader2 size={14} className="animate-spin"/> : <Wand2 size={14}/>} Auto-Setup ⚡
                            </button>
                            <button 
                                onClick={handleFetchTemplates} 
                                disabled={isFetchingTemplates} 
                                className="text-[11px] font-bold text-indigo-600 bg-indigo-50 hover:bg-indigo-100 px-3 py-1.5 rounded-lg flex items-center gap-2 transition-colors disabled:opacity-50"
                            >
                                {isFetchingTemplates ? <Loader2 size={14} className="animate-spin"/> : <RefreshCw size={14}/>} Sync Meta
                            </button>
                        </div>
                     </div>
                      
                     <div className="bg-white border border-slate-200 rounded-xl md:rounded-2xl p-1 shadow-sm transition-all focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-50/50">
                         {metaTemplates.length > 0 ? (
                            <div className="flex flex-col gap-2 p-1">
                                <select value={selectedTemplateIndex} onChange={handleTemplateSelect} className="w-full p-2 md:p-2.5 rounded-lg border-none bg-transparent text-xs md:text-sm font-bold text-slate-800 outline-none cursor-pointer focus:ring-0">
                                    <option value="">Choose an approved template...</option>
                                    {metaTemplates.map((t, idx) => (
                                        <option key={t.id} value={idx}>{t.name} ({t.language})</option>
                                    ))}
                                </select>
                            </div>
                         ) : (
                            <div className="p-3 md:p-4 text-center bg-slate-50 rounded-lg md:rounded-xl">
                                <p className="text-[10px] md:text-xs font-bold text-slate-400 mb-2 md:mb-3">Click 'Sync Meta' to load templates</p>
                                <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center pt-2 md:pt-3 border-t border-slate-200">
                                    <span className="w-full text-[8px] md:text-[9px] text-slate-400 uppercase tracking-widest font-black">Fallback Static Templates</span>
                                    {templates.map((t, idx) => (
                                        <button key={idx} onClick={() => setCustomMessage(t.text)} className="px-2.5 py-1 md:px-3 md:py-1.5 rounded-lg border border-slate-200 bg-white text-[9px] md:text-[10px] font-bold text-slate-600 hover:bg-slate-100 transition-all shadow-sm">{t.title}</button>
                                    ))}
                                </div>
                            </div>
                         )}
                     </div>
                  </div>

                  {/* Step 3: Message Editor + Image Upload */}
                  <div className="space-y-3 flex-1 flex flex-col min-h-[300px]">
                     <h3 className="text-[10px] md:text-xs font-black text-slate-400 uppercase tracking-widest flex items-center gap-2">
                        <span className="w-4 h-4 md:w-5 md:h-5 rounded-full bg-slate-100 flex items-center justify-center text-[9px] md:text-[10px] text-slate-600">3</span> 
                        Message Content & Variables
                     </h3>
                     <div className="flex-1 flex flex-col border border-slate-200 rounded-xl md:rounded-2xl overflow-hidden focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-50/50 transition-all shadow-sm bg-white">
                        <div className="bg-slate-50/80 border-b border-slate-200 p-1.5 md:p-2.5 px-3 md:px-4 flex justify-between items-center shrink-0">
                           <div className="flex gap-1.5 items-center">
                              <button onClick={() => insertText('*Bold*')} className="w-6 h-6 md:w-8 md:h-8 flex items-center justify-center text-slate-500 hover:text-slate-800 hover:bg-slate-200 rounded-md md:rounded-lg transition-colors"><Bold size={12} className="md:w-4 md:h-4"/></button>
                              <button onClick={() => insertText('_Italic_')} className="w-6 h-6 md:w-8 md:h-8 flex items-center justify-center text-slate-500 hover:text-slate-800 hover:bg-slate-200 rounded-md md:rounded-lg transition-colors"><Italic size={12} className="md:w-4 md:h-4"/></button>
                              <button onClick={() => insertText('~Strike~')} className="w-6 h-6 md:w-8 md:h-8 flex items-center justify-center text-slate-500 hover:text-slate-800 hover:bg-slate-200 rounded-md md:rounded-lg transition-colors"><Strikethrough size={12} className="md:w-4 md:h-4"/></button>
                              
                              {/* 🖼️ IMAGE ATTACH BUTTON */}
                              <div className="w-px h-4 md:h-5 bg-slate-300 mx-1"></div>
                              <label className="w-6 h-6 md:w-8 md:h-8 flex items-center justify-center text-indigo-500 hover:text-indigo-700 hover:bg-indigo-100 rounded-md md:rounded-lg transition-colors cursor-pointer" title="Attach Image">
                                 <ImagePlus size={14} className="md:w-5 md:h-5"/>
                                 <input type="file" accept="image/*" className="hidden" onChange={handleImageSelect} />
                              </label>
                           </div>
                           {selectedTemplateIndex === "" && (
                               <button onClick={() => insertText('[Name]')} className="text-[9px] md:text-[11px] font-black text-indigo-600 bg-indigo-100 hover:bg-indigo-200 px-2 md:px-3 py-1 md:py-1.5 rounded-md md:rounded-lg transition-colors tracking-widest uppercase">
                                  + Add [Name]
                               </button>
                           )}
                        </div>

                        {/* 📝 DYNAMIC CONTENT AREA */}
                        {selectedTemplateIndex !== "" && templateVariables.length > 0 ? (
                            <div className="flex-1 w-full p-4 md:p-6 space-y-6 overflow-y-auto custom-scrollbar bg-slate-50/30">
                                {templateVariables.map((val, index) => (
                                    <div key={index} className="bg-white border border-slate-200 p-4 md:p-5 rounded-xl shadow-sm relative group hover:border-indigo-300 transition-colors">
                                        <div className="absolute -top-2.5 left-4 bg-white px-2 text-[10px] font-black text-indigo-600 uppercase tracking-widest border border-slate-100 rounded-md shadow-sm">
                                            Variable {'{{' + (index + 1) + '}}'}
                                        </div>
                                        
                                        {index === 0 ? (
                                            <div className="flex items-center gap-2 text-slate-500 bg-slate-50 p-3 rounded-lg border border-slate-100 mt-2">
                                                <span className="text-sm font-bold">[Lead Name Auto-Filled]</span>
                                            </div>
                                        ) : (
                                            <textarea 
                                                rows="2"
                                                value={val}
                                                onChange={(e) => handleVariableChange(index, e.target.value)}
                                                placeholder={`Enter content for {{${index + 1}}}...`}
                                                className="w-full mt-2 p-0 border-none text-sm font-medium text-slate-800 placeholder:text-slate-400 focus:ring-0 outline-none resize-none custom-scrollbar"
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <textarea 
                               value={customMessage} 
                               disabled={!selectedClientId} 
                               onChange={(e) => setCustomMessage(e.target.value)} 
                               className="w-full flex-1 p-4 md:p-6 outline-none resize-none text-xs md:text-sm text-slate-700 disabled:bg-slate-50 leading-relaxed font-medium custom-scrollbar min-h-[150px]" 
                               placeholder="Type your WhatsApp broadcast message here..."
                            ></textarea>
                        )}

                        {/* 🖼️ SMALL ATTACHMENT PREVIEW BAR */}
                        {imagePreviewUrl && (
                           <div className="p-3 bg-white border-t border-slate-200 flex items-center gap-3 shrink-0 animate-in slide-in-from-bottom-2">
                               <img src={imagePreviewUrl} alt="preview" className="w-10 h-10 md:w-12 md:h-12 object-cover rounded-lg shadow-sm border border-slate-200" />
                               <div className="flex-1 min-w-0">
                                   <p className="text-[10px] md:text-xs font-bold text-slate-800 truncate">{campaignImage?.name}</p>
                               </div>
                               <button onClick={removeImage} className="text-rose-500 hover:text-rose-700 hover:bg-rose-50 p-2 rounded-lg transition-colors border border-transparent hover:border-rose-200">
                                   <X size={16}/>
                               </button>
                           </div>
                        )}
                     </div>
                  </div>
               </div>

               {/* RIGHT PANEL: Live Phone Preview */}
               <div className="hidden lg:flex w-[45%] bg-slate-100/50 border-l border-slate-200 p-6 items-center justify-center relative overflow-hidden h-full">
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[150%] h-[150%] bg-gradient-to-br from-indigo-100 to-emerald-50 opacity-50 blur-3xl rounded-full pointer-events-none"></div>

                  <div className="w-[260px] max-h-[480px] h-full bg-slate-900 rounded-[35px] shadow-[0_10px_40px_rgba(0,0,0,0.15)] p-2 relative z-10 shrink-0 ring-2 ring-slate-800 flex flex-col mx-auto aspect-[9/19]">
                     <div className="absolute top-3 left-1/2 -translate-x-1/2 w-[70px] h-[20px] bg-black rounded-full z-30 shadow-inner"></div>
                     
                     <div className="w-full h-full bg-[#efeae2] rounded-[28px] overflow-hidden flex flex-col relative border border-slate-800">
                        
                        <div className="bg-[#008069] pt-9 pb-2.5 px-3 flex items-center gap-2.5 text-white shadow-md relative z-20 shrink-0">
                           <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center font-black text-xs backdrop-blur-sm">R</div>
                           <div>
                              <h4 className="text-[13px] font-bold leading-none">Rahul Sharma</h4>
                              <p className="text-[9px] text-white/80 font-medium mt-0.5">Live Preview</p>
                           </div>
                        </div>

                        <div className="flex-1 p-2.5 overflow-y-auto custom-scrollbar relative flex flex-col items-start h-full">
                           <div className="absolute inset-0 opacity-[0.06] pointer-events-none z-0" style={{ backgroundImage: 'radial-gradient(#000 1px, transparent 1px)', backgroundSize: '16px 16px' }}></div>
                           
                           <div className="w-full flex justify-center mb-3 mt-1.5 relative z-10">
                              <span className="bg-[#E1F3FB] text-slate-600 text-[8px] font-bold px-2 py-1 rounded-md shadow-sm">TODAY</span>
                           </div>
                           
                           {/* 🖼️ Dynamic Chat Bubble with Image */}
                           <div className="bg-white p-2 rounded-xl rounded-tl-sm shadow-sm max-w-[90%] text-[12px] text-slate-800 relative self-start group z-10 flex flex-col">
                              {imagePreviewUrl && (
                                 <div className="mb-1.5 w-full rounded-lg overflow-hidden border border-slate-100 bg-slate-100">
                                    <img src={imagePreviewUrl} alt="Chat Media" className="w-full h-auto max-h-[120px] object-cover" />
                                 </div>
                              )}

                              <div className="whitespace-pre-wrap pr-8 leading-relaxed font-normal">
                                 {getLivePreviewText()}
                              </div>
                              <span className="text-[8px] text-slate-400 absolute bottom-1 right-1.5 font-medium bg-white/90 px-1 rounded">12:00 PM</span>
                              <div className="absolute top-0 -left-1 w-0 h-0 border-t-[8px] border-t-white border-l-[8px] border-l-transparent"></div>
                           </div>

                           {isCampaignRunning && (
                               <div className="absolute inset-0 bg-white/60 backdrop-blur-sm z-30 flex flex-col items-center justify-center">
                                   <div className="bg-white px-4 py-3 rounded-2xl shadow-xl border border-indigo-100 flex flex-col items-center gap-2">
                                       <Loader2 size={24} className="text-indigo-600 animate-spin"/>
                                       <span className="text-xs font-black text-slate-800 uppercase tracking-widest">Dispatching</span>
                                   </div>
                               </div>
                           )}
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* 3. Footer Action Bar */}
            <div className="px-6 md:px-8 py-3.5 md:py-4 border-t border-slate-200 bg-white flex flex-col sm:flex-row justify-between items-center z-10 shrink-0 gap-3 md:gap-4">
               <div className="flex items-center gap-3 md:gap-4 w-full sm:w-auto">
                  <div className={`w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center shrink-0 ${canAffordCampaign(selectedRows.length) ? 'bg-emerald-50 text-emerald-500' : 'bg-rose-50 text-rose-500'}`}>
                     <IndianRupee size={16} className="md:w-5 md:h-5"/>
                  </div>
                  <div>
                     <h4 className="text-xs md:text-sm font-black text-slate-900 leading-none mb-1">Campaign Cost</h4>
                     <p className={`text-[10px] md:text-[11px] font-bold ${canAffordCampaign(selectedRows.length) ? 'text-emerald-600' : 'text-rose-600'}`}>
                         Estimated Cost: ₹{(selectedRows.length * MESSAGE_COST).toFixed(2)}
                     </p>
                  </div>
               </div>
               
               <div className="flex items-center gap-2.5 md:gap-3 w-full sm:w-auto justify-end">
                  <button onClick={() => setIsComposeOpen(false)} disabled={isCampaignRunning} className="px-3 md:px-4 py-2 md:py-3 text-[10px] md:text-[11px] font-black text-slate-500 hover:text-slate-800 transition-colors uppercase tracking-widest disabled:opacity-50">
                     Cancel
                  </button>
                  <button 
                     onClick={handleSendCustomMessage} 
                     disabled={isCampaignRunning || (!customMessage && !campaignImage && templateVariables.length === 0) || !selectedClientId} 
                     className={`px-4 md:px-6 py-2.5 md:py-3 rounded-lg md:rounded-xl text-[10px] md:text-[11px] font-black text-white flex items-center gap-1.5 md:gap-2 shadow-md transition-all disabled:opacity-50 disabled:shadow-none uppercase tracking-widest ${canAffordCampaign(selectedRows.length) ? 'bg-indigo-600 hover:bg-indigo-700 shadow-indigo-200' : 'bg-slate-300'}`}
                  >
                     {canAffordCampaign(selectedRows.length) ? (
                         <>
                             {isCampaignRunning ? <Loader2 size={14} className="animate-spin"/> : <Send size={14}/>}
                             {isCampaignRunning ? 'Dispatching...' : 'Launch Broadcast'}
                         </>
                     ) : (
                         "No Balance"
                     )}
                  </button>
               </div>
            </div>
            
          </div>
        </div>,
        document.body 
      )}

      {/* PREVIEW MODAL (SEO DRIP) */}
      {isPreviewOpen && createPortal(
          <div className="fixed inset-0 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in" style={{ zIndex: 99999 }}>
              <div className="bg-white rounded-[2rem] w-full max-w-md shadow-2xl overflow-hidden animate-in zoom-in duration-200">
                  <div className="p-6 bg-slate-50 border-b flex justify-between items-center">
                      <div className="flex items-center gap-2">
                        <div className="bg-indigo-600 p-1.5 rounded-lg text-white"><Send size={16}/></div>
                        <h3 className="font-black text-sm uppercase tracking-widest text-slate-800">SEO Drip Ready</h3>
                      </div>
                      {!isCampaignRunning && <button onClick={() => setIsPreviewOpen(false)} className="text-slate-400 hover:text-rose-500"><X size={20}/></button>}
                  </div>
                  <div className="p-6 space-y-4">
                      <div className={`p-4 rounded-xl border flex items-start gap-3 mb-2 ${canAffordCampaign(selectedForCampaign.length) ? 'bg-indigo-50 border-indigo-100' : 'bg-rose-50 border-rose-200'}`}>
                          <div className={`p-1.5 rounded-lg ${canAffordCampaign(selectedForCampaign.length) ? 'bg-indigo-100 text-indigo-600' : 'bg-rose-100 text-rose-600'}`}><IndianRupee size={16}/></div>
                          <div>
                              <p className={`text-[10px] font-black uppercase tracking-widest mb-0.5 ${canAffordCampaign(selectedForCampaign.length) ? 'text-indigo-600' : 'text-rose-600'}`}>Estimated Cost</p>
                              <p className="text-xs font-bold text-slate-700">{selectedForCampaign.length} Messages x ₹{MESSAGE_COST.toFixed(2)} = <span className={canAffordCampaign(selectedForCampaign.length) ? 'text-indigo-600' : 'text-rose-600 font-black'}>₹{(selectedForCampaign.length * MESSAGE_COST).toFixed(2)}</span></p>
                          </div>
                      </div>
                      <p className="text-xs font-bold text-slate-500 uppercase tracking-wide">AI selected {selectedForCampaign.length} students:</p>
                      <div className="space-y-2 max-h-48 overflow-y-auto custom-scrollbar pr-1">
                          {selectedForCampaign.map((s, idx) => (
                              <div key={idx} className="flex items-center justify-between bg-slate-50 p-3 rounded-xl border border-slate-100">
                                  <div className="flex items-center gap-3">
                                      <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center text-[10px] font-black text-indigo-600 border border-indigo-100 shadow-sm">{s.studentName?.[0]}</div>
                                      <div>
                                          <p className="text-[13px] font-black text-slate-800 leading-none">{s.studentName}</p>
                                          <p className="text-[10px] text-slate-400 font-mono mt-1">+{s.phone}</p>
                                      </div>
                                  </div>
                                  {idx < progressCount ? <CheckCircle size={18} className="text-emerald-500 animate-in zoom-in" /> : isCampaignRunning && idx === progressCount ? <Loader2 size={18} className="text-indigo-500 animate-spin" /> : <div className="w-4 h-4 rounded-full border-2 border-slate-200" />}
                              </div>
                          ))}
                      </div>
                  </div>
                  <div className="p-6 pt-0">
                      <button 
                        onClick={handleLaunchCampaign}
                        disabled={isCampaignRunning || !canAffordCampaign(selectedForCampaign.length)}
                        className={`w-full text-white font-black py-4 rounded-2xl text-sm uppercase tracking-widest transition-all flex items-center justify-center gap-2 shadow-xl disabled:opacity-70 ${canAffordCampaign(selectedForCampaign.length) ? 'bg-slate-900 hover:bg-indigo-600 shadow-indigo-100' : 'bg-slate-300'}`}
                      >
                          {canAffordCampaign(selectedForCampaign.length) ? (isCampaignRunning ? <><Loader2 size={18} className="animate-spin"/> Sending Messages...</> : "Confirm & Launch 🚀") : "Insufficient Balance"}
                      </button>
                  </div>
              </div>
          </div>,
          document.body 
      )}
    </div>
  );
};

export default AudienceManager;